import * as R from "ramda";
import { Status, MEDIA_URL, MEDIA_URL1, APPROVAL_STATUS } from "./constants";

export const normalizedAgencies = (agencies) => {
  let res = [{ value: "", name: "None" }];
  for (let i = 0; i < agencies.length; i++) {
    res.push({ value: agencies[i], name: agencies[i] });
  }
  return res;
};

export const normalizeStatus = (status) => {
  for (let i = 0; i < Status.length; i++) {
    if (Status[i].value == status) {
      return Status[i].name;
    }
  }
};

export const parseStatus = (is_active) => {
  if (is_active) {
    return "Active";
  } else {
    return "Inactive";
  }
};

export const parseImageUrl = (img) => {
  if (!img) {
    return "https://via.placeholder.com/300.png";
  }
  if (img && img.search("localhost:8000") > 0) {
    return img.replace("http://localhost:8000", MEDIA_URL);
  } else {
    return MEDIA_URL + img;
  }
};

export const parseImageUrl1 = (img) => {
  if (!img) {
    return "https://via.placeholder.com/300.png";
  }
  if (img && img.search("localhost:8000") > 0) {
    return img.replace("http://localhost:8000", MEDIA_URL1);
  } else {
    return MEDIA_URL1 + img;
  }
};

export const fullURL = (url) => {
  if (url && url.search("localhost:8000") > 0) {
    return url.replace("http://localhost:8000", MEDIA_URL);
  } else {
    return MEDIA_URL + url;
  }
};

// Manage query params
export const onChangePage = (query, setQuery) => (page) => {
  const newPage = page + 1;
  setQuery(R.mergeDeepRight(query, { page: newPage }), "push");
};
export const onChangePageSize = (query, setQuery) => (page_size) => {
  setQuery(R.mergeDeepRight(query, { page_size, page: 1 }), "push");
};
export const onChangeSort = (query, setQuery) => (ordering) => {
  setQuery(R.mergeDeepRight(query, ordering), "push");
};
export const onReset = (defaultQuery, query, setQuery) => () => {
  setQuery(R.mergeDeepRight(query, defaultQuery), "push");
};

export const filterUndefinedFields = (obj) => {
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === "undefined" || obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
};

export const checkRole = (session) => {
  if (session && session.membership && session.membership.role) {
    return session.membership.role.id;
  } else {
    return false;
  }
};

export const getUrlExt = (url) => {
  return url.split("?")[0].split(".").pop().trim().toLowerCase();
};

export const scrollToElement = (refId) => {
  setTimeout(() => {
    refId.current?.scrollIntoView({ behavior: "smooth" });
  }, 100);
};

export const concactId = (data) => {
  let str = "";
  for (let i = 0; i < data.length; i++) {
    if (i > 0) {
      str += `,${data[i]?.id}`;
    } else {
      str += data[i]?.id;
    }
  }
  return str;
};

const overlapping = (a, b) => {
  const getMinutes = (s) => {
    const p = s.split(":").map(Number);
    return p[0] * 60 + p[1];
  };
  return (
    getMinutes(a.end) > getMinutes(b.start) &&
    getMinutes(b.end) > getMinutes(a.start)
  );
};
export const isOverlapping = (arr) => {
  let i, j;
  for (i = 0; i < arr.length - 1; i++) {
    for (j = i + 1; j < arr.length; j++) {
      if (overlapping(arr[i], arr[j])) {
        return true;
      }
    }
  }
  return false;
};

export const diffMinutes = (dt2, dt1, getAbsolute = true) => {
  if (dt1 && dt2) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return getAbsolute ? Math.abs(Math.round(diff)) : Math.round(diff);
  }
};

export const isClassRoomDisabled = (item, role) => {
  if (role === 4) {
    return true
  }
  const { created_by, status } = item;
  const createdByRole = created_by?.role_id;
  let flag = false;
  let published = false;

  if (status === "pending" || status === "published" || status === "approved") {
    published = true;
  }
  if (published && role === 3) {
    flag = true;
  }
  if (status === "pending" || (item.published === true && role <= 2)) {
    flag = true;
  }
  return flag;
};

export const isAlphaNumaric = (text) => {
  return /^[a-zA-Z0-9\s]*$/.test(text);
};

export const getFileName = (file) => {
  if (file) {
    const fullFileName = file.split("?X")[0];
    const fullFileNameExtensionIndex = fullFileName.lastIndexOf("/");
    const fileName = fullFileName.slice(fullFileNameExtensionIndex + 1);
    return fileName;
  }
};

export const futureDateTime = (date, mins) => {
  date.setMinutes(date.getMinutes() + mins);
  return date;
};

export const getPercentPostfix = (val) => {
  return !!val && parseFloat(val) > 0 ? `${Number(val).toFixed(0)}%` : 0;
};
export const getFileExtension = (fileName) => {
  const fileNameArr = fileName.split(".");
  return fileNameArr[fileNameArr.length - 1].toLowerCase()?.split("?")[0];
};

export const isValidUrl = (userInput) => {
  const res = userInput.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)/g
  );
  return res !== null;
};

export const isCourseActionDisabled = (isPublished, courseStatus) => {
  return isPublished || APPROVAL_STATUS.includes(courseStatus);
};

export const convertTimeFrom24Hto12H = (time) => {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? "AM" : "PM";
    time[0] = +time[0] % 12 || 12;
  }
  time[3] = " ";
  return time.join("");
};

export const isApprover = () => {
  const isApprover = new URLSearchParams(document.location.search).get(
    "requestflow"
  );
  return !!isApprover;
};

export const getMillisecond = (time) => {
  //converts time format hh:mm:ss into millisecond
  const msArr = time.split(":");
  let ms =
    Number(msArr[0]) * 60 * 60 * 1000 +
    Number(msArr[1]) * 60 * 1000 +
    Number(msArr[2]) * 1000;
  return ms;
};
export const checkForValidFile = (files, acceptedFileTypes) => {
  let allFilesValid = true;
  if (!(files.length > 0)) {
    return false;
  }

  for (let i = 0; i < Object.keys(files).length; i++) {
    let fileExtension = getFileExtension(files[i].name);
    if (!acceptedFileTypes.includes(fileExtension)) {
      allFilesValid = false;
      return allFilesValid;
    }
  }

  return allFilesValid;
};

export const getTimestampByDateTime = (date, time) => {
  const dateTime = `${date} ${time}`;
  const timestamp = new Date(dateTime).getTime();
  if (timestamp > 1000) {
    return timestamp;
  } else {
    return 1000;
  }
};

export const isFileNameTooLarge = (fileName, maxLength) => {
  return fileName.length <= maxLength;
};

export const removeHtmlEntities = (input) => {
  let doc = new DOMParser().parseFromString(input, "text/html");
  return doc.body.textContent || "";
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const getHTMLTagsRemovedString = (str) => {
  return str?.replace(/<[^>]*>?/gm, "");
};
